<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="true"
    :title="$t('scripting.packageConfirmation')"
    :visible.sync="printTipsVisible"
    top="10vh"
    width="650px"
  >
    <div style="max-height: 500px; overflow-y: auto">
      <table class="confirm-table">
        <!-- 扫描信息 -->
        <tr>
          <td class="label">{{ $t('collectionCenter.scanInfo') }}:</td>
          <td class="value" colspan="2">{{ tipDataList[0].number || '-' }}</td>
        </tr>
        <!-- 关联包裹数量 -->
        <tr>
          <td class="label">{{ $t('scripting.associatedPackageCount') }}:</td>
          <td class="value" colspan="2">{{ tipDataList.length || 0 }}</td>
        </tr>
        <!-- 第一行运单 -->
        <tr>
          <td class="label">{{ $t('scripting.packageWaybillNumber') }}:</td>
          <td class="value">{{ tipDataList[0].waybillNumber || '-' }}</td>
          <!-- 👇 关键：判断是否隐藏按钮 -->
          <td v-if="tipDataList[0].bagNumber" class="operate" @click="removeBag(0)">
            {{ $t('GlobalSetObj.RemoveOutBag') }}
          </td>
        </tr>
        <!-- 剩下的运单行 -->
        <tr v-for="(item, index) in (tipDataList || []).slice(1)" :key="index">
          <td class="label" />
          <td class="value">{{ item.waybillNumber }}</td>
          <!-- 👇 关键：判断是否隐藏按钮 -->
          <td v-if="item.bagNumber" class="operate" @click="removeBag(index + 1)">
            {{ $t('GlobalSetObj.RemoveOutBag') }}
          </td>
        </tr>
      </table>
    </div>
    <div style="margin-left: 30px; color: red">{{ $t('scripting.verifyPackageCountNotice') }}</div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="printTipsVisible = false">
        {{ $t('scripting.cancelPrint') }}
      </el-button>
      <el-button size="small" type="primary" @click="clickPrint">
        {{ $t('GlobalSetObj.Confirmed') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { removeBag } from '@/api/automaticSorting';

export default {
  name: 'PackageConfirmDialog',
  data() {
    return {
      printTipsVisible: false,
      tipDataList: []
    };
  },
  methods: {
    showTip(arg) {
      this.tipDataList = arg;
      this.printTipsVisible = true;
    },
    async removeBag(index) {
      const data = {
        bagNumber: this.tipDataList[index].bagNumber,
        collectOrderId: this.tipDataList[index].collectOrderId,
        waybillNumber: this.tipDataList[index].waybillNumber
      };
      console.log(data, '移除成功data');
      const res = await removeBag(data);
      if (res.code === 200) {
        console.log('移除成功');
        // ✅ 核心：只隐藏当前行按钮，不删除行
        this.$set(this.tipDataList[index], 'bagNumber', null);
      }
    },
    clickPrint() {
      // 增加传参, 判断是否确定打印
      this.$emit('autoPrint', 1);
      this.printTipsVisible = false;
    }
  }
};
</script>

<style scoped>
.confirm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
}

.confirm-table .label {
  padding: 5px;
  text-align: right;
  white-space: nowrap;
  width: 1%;
}

.confirm-table .value {
  padding: 5px;
  color: #409eff;
  word-break: break-all;
}

.confirm-table .operate {
  padding: 5px;
  text-align: center;
  cursor: pointer;
  color: red;
  width: 1%;
  white-space: nowrap;
}

.dialog-footer {
  text-align: right;
  margin-top: 8px;
}
</style>
